import React from 'react';
import Moment from 'react-moment';

export const DateRange = ({start, end}) => {
  //const sd = new Date(start);
  //const ed = new Date(end);

  const startDate = start && (<Moment format='YYYY' utc>{start}</Moment>);
  const endDate = end && (<Moment format='YYYY' utc>{end}</Moment>);


  if (end !== "0001-01-01") {
    return (
      <React.Fragment>{startDate} &mdash; {endDate}</React.Fragment>
    );
  } else if (startDate && start !== "0001-01-01") {
    return (
      <React.Fragment>b. {startDate}</React.Fragment>
    )
  } else {
    return null;
  }
};